import { resolvePitchApiBase } from "./pitchFeed.js";

const TOKEN_KEY = "pitch_admin_jwt";

/** Same base as public feed: empty in dev (Vite proxies `/v1`); prod uses env or tab origin. */
function resolveAdminUrl(path) {
  const p = String(path ?? "");
  if (/^https?:\/\//i.test(p)) return p;
  const base = resolvePitchApiBase();
  const rel = p.startsWith("/") ? p : `/${p}`;
  return `${base}${rel}`;
}

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function adminFetch(path, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  const t = getAdminToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(resolveAdminUrl(path), { ...options, headers });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { raw: text };
  }
  if (!res.ok) {
    const err = new Error(data?.error || res.statusText || "request_failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}